import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "RETAILER_LIST_ERROR":
            return action.error;

        case "RETAILER_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "RETAILER_LIST_LOADING":
            return action.loading;

        case "RETAILER_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case "RETAILER_LIST_SUCCESS":
            return action.retrieved;

        case "RETAILER_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function countRetrieved(state = false, action) {
    switch (action.type) {
        case "RETAILER_LIST_COUNT_SUCCESS":
            return action.retrieved;

        case "RETAILER_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export function countLoading(state = false, action) {
    switch (action.type) {
        case "RETAILER_LIST_COUNT_LOADING":
            return action.loading;

        case "RETAILER_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved, countRetrieved, countLoading});
